import css from './InfoLayer.css'
import { stopRKey, fireEvent, jsFadeOut, jsFadeIn, ajaxPost } from '../../lib/jsfunc.js'
import * as cart from '../../lib/cart.js'
import { on, ready, query, queryAll } from '../../lib/dom.js'

ready(function () {
  if(!query('.InfoLayer')) return false;

  document.onkeypress = stopRKey;

  on(document.body, 'click', function(event) {
    var div = event.target.closest( 'div');
    var popup = query('.infolayer-cart-popup');
    if( (typeof div) == 'undefined' && popup ){
      var popupClose = query('.infolayer-cart-popup .icons-reset-white');
      if (popupClose) {
        fireEvent(popupClose,'click');
      }
    }
  })
})

on('click','.InfoLayer > div:first-child > span', function(event) {
  event.preventDefault();
  var InfoLayer = event.target.closest('.InfoLayer');
  if(InfoLayer){
    jsFadeOut(InfoLayer);
  }
  return false;
})

on('mouseover', '.panel-produkte.show-infolayer', function(event) {
  var infolayer = query('.InfoLayer.infolayer-3dviewer');
  if(infolayer.style.opacity < 0.9){
    setTimeout(function(){ jsFadeIn(infolayer,0.9); }, 1000);
    setTimeout(function(){ fireEvent(query(infolayer,'div:first-child > span'), 'click'); }, 15000);
  }
  event.target.closest('.show-infolayer').classList.remove('show-infolayer');
})

on('change', '.infolayer-cart-popup table.cart td.anzahl input', function(event) {
  event.preventDefault();

  var table = event.target.closest( 'table');
  var sendrequest = table.getAttribute('data-sendrequest');
  var inrequest = table.getAttribute('data-inrequest');
  if(sendrequest){
    table.setAttribute('data-inrequest', true);
    table.setAttribute('data-sendrequest', false);
    if(cart.checkInputPopup(event.target)){
      var anzahl = cart.setMindestmengePopup(event);

      if(anzahl > 0){
        var url = event.target.closest( 'tr').getAttribute('data-url');
        if(url){
          ajaxPost(url, {'anzahl': anzahl }, function(request){
            cart.updateTable(JSON.parse(request.responseText), table);
          });
        }
      }else{
        event.target.value = '';
        var a = query(event.target.closest('td'), 'a.loeschen .icons-trash');
        fireEvent(a ,'click');
      }
    }
    table.setAttribute('data-inrequest', false);
    table.setAttribute('data-sendrequest', true);
  }
})

on('keyup', '.infolayer-cart-popup table.cart td.anzahl input', function(event) {
  fireEvent(event.target, 'change');
})